import { useCallback } from "react";

import type { EcReceiptEmailResendInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { EcReceiptEmailResend_ECReceiptDetailPage_Mutation } from "./mutation";

export const useResendECReceiptEmail = () => {
	const { mutationFunc } = useCustomMutation(
		EcReceiptEmailResend_ECReceiptDetailPage_Mutation, //
	);

	const resendECReceiptEmail = useCallback(
		async (input: EcReceiptEmailResendInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return {
		resendECReceiptEmail,
	};
};
